export const preventCopy = () => {
    // 禁止复制
    // document.addEventListener('copy', (e) => {
    //     e.preventDefault();
    //     return false;
    // });

    // 禁止剪切
    document.addEventListener('cut', (e) => {
        e.preventDefault();
        return false;
    });

    // 禁止粘贴
    // document.addEventListener('paste', (e) => {
    //     e.preventDefault();
    //     return false;
    // });

    // 禁止选择文本
    document.addEventListener('selectstart', (e) => {
        e.preventDefault();
        return false;
    });

    // 禁用右键菜单
    document.addEventListener('contextmenu', (e) => {
        e.preventDefault();
        return false;
    });

    // 禁用文本选择样式
    const style = document.createElement('style');
    style.innerHTML = `
    * {
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  `;
    document.head.appendChild(style);
};